// extracted by mini-css-extract-plugin
export var deleteModal = "_hn-0";